export default "__VITE_ASSET__DE9iXd50__"